import { ref } from 'vue';

export const useModal = () => {
  const isOpen = ref<boolean>(false);

  const openModal = (): void => {
    isOpen.value = true;
  };

  const closeModal = (): void => {
    isOpen.value = false;
  };

  const toggleModal = (): void => {
    isOpen.value = !isOpen.value;
  };

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
  };
};
